const ATTACHMENT_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.xls',
  '.ppt',
  '.mobi',
  '.epub',
  '.vcf',
];

const acceptInputAttachmentsList = ATTACHMENT_EXTENSIONS.join(',');

export { acceptInputAttachmentsList, ATTACHMENT_EXTENSIONS };
